import axios from 'axios';
import { PARAMS } from '../../const';
import { API_GROUPS_STUDENTS, API_GROUPS } from '../../services/api/apiConst';
import { manageArrayResponse } from './apiResponse';
import { I18n } from 'react-redux-i18n-lite';
import * as _ from 'lodash';
import { getLogger } from '../logger';

const debug = getLogger('services:api:groupApi');

export let getStudents = groupId => {
  if (groupId) {
    let url = API_GROUPS_STUDENTS.replace(PARAMS.GROUP, groupId);
    return manageArrayResponse(axios.get(url));
  }
  debug.error('[getStudents] Group id is empty');
};

/**
 * If the group is a defaultGroup use the translation module to write the first character
 * @param group
 * @returns {string}
 */
export let getGroupFirstChar = group => {
  return I18n.t('groups.' + group.name).charAt(0);
};

/**
 *  * If the group is a defaultGroup use the translation module to write the name
 * @param group
 */
export let getGroupName = group => {
  if (group.defaultGroup) {
    return I18n.t('groups.' + group.name);
  }
  return group.name;
};

export let getOrderedGroups = groups => {
  let groupList;
  if (groups && groups[0]) {
    let all = groups[0];
    let onlyGroups = groups.slice(1);
    groupList = _.sortBy(onlyGroups, group => {
      return getGroupName(group);
    });
    groupList = [all].concat(groupList);
  }
  return groupList;
};

export let editGroup = (groupId, newName, classroomId) => {
  if (groupId && newName && classroomId) {
    const baseUrl = API_GROUPS.replace('/groups', '');
    const url = `${baseUrl}/classrooms/${classroomId}/groups/${groupId}`;
    console.log('[editGroup] Making PUT request to:', url, 'with data:', { name: newName });
    
    // Verificar que el token esté disponible
    const token = localStorage.getItem('smartAuthToken');
    console.log('[editGroup] Token available:', !!token);
    
    return axios.put(url, { name: newName });
  }
  debug.error('[editGroup] Group id, name or classroom id is empty');
};
